// import store from '../index'
import { activitySelect, virtualExchangeCodeSelect } from "@/api/activity";

export default {
  namespaced: true,
  state: () => ({
    addressSelectVO: [],
    citySelectVO: [],
    coachSelectVO: [],
    equipmentSelectVO: [],
    movingSelectVO: [],
    uaEventLabelSelectVOS: [], // ua活动标签
    suitableForPeopleSelectVO: [],
    coachLevalVO: [],
    coachLevels: [],
    titleSelectVO: [],
    couponDetail: {},
  }),
  mutations: {
    set_select: (state, data) => {
      state.coachLevalVO = Array.from(
        new Set(
          data.coachSelectVO.reduce((init, item) => {
            if (item.level) init.push(item.level);
            return init;
          }, [])
        )
      );
      state = Object.assign(state, data);
    },
    set_title: (state, data) => {
      state.titleSelectVO = data;
    },
    set_coupon: (state, data) => {
      state.couponDetail = data;
    },
  },
  actions: {
    async getSelect({ commit, state }) {
      await activitySelect().then(data => {
        commit("set_select", data);
      });
    },
    async getTitles({ commit, state }) {
      await virtualExchangeCodeSelect().then(data => {
        commit("set_title", data);
      });
    },
    async setCouponDetail({ commit }, data) {
      await commit("set_coupon", data);
    },
  },
};
